// 12.09.2023
const data = {
  "success": true,
  "message": "Scheme",
  "data": [
    "3126756467172967353",
    "30029437",
    "30029438",
    "30029439",
    "30029440",
    "30029441",
    "30029442",
    "30029443",
    "30029444",
    "30029445",
    "30029446",
    "30029447",
    "30029448",
    "30029449",
    "30029450",
    "30029451",
    "30029452",
    "30029453",
    "30029454",
    "30029455",
    "30029456",
    "30029457",
    "30030274",
    "30048773",
    "30055733",
    "3052976251863041408",
    "3052990794169319681",
    "3052990794169319685",
    "3053035016008237372",
    "3053035016008237833",
    "3125292474268909605",
    "3126756467172966415",
    "3126756467172966417",
    "3126756467172966419",
    "3126756467172966421",
    "3126756467172966423",
    "3126756467172966425",
    "3126756467172966427",
    "3126756467172966429",
    "3126756467172966431",
    "3126756467172966433",
    "3126756467172966435",
    "3126756467172966437",
    "3126756467172966439",
    "3126756467172966441",
    "3126756467172966443",
    "3126756467172966445",
    "3126756467172966447",
    "3126756467172966449",
    "3126756467172966451",
    "3126756467172966453",
    "3126756467172966457",
    "3126756467172966462",
    "3126756467172966472",
    "3126756467172966476",
    "3126756467172967001",
    "3126756467172967218",
    "3126756467172967225",
    "3126756467172967232",
    "3126756467172967240",
    "3126756467172967247",
    "3126756467172967254",
    "3126756467172967261",
    "3126756467172967268",
    "3126756467172967275",
    "3126756467172967282",
    "3126756467172967289",
    "3126756467172967296",
    "3126756467172967307"
  ]
}

export default data;
